import { classNames } from 'libs/react';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import './DropdownMenuItem.scss';
/**
 * @component DropdownMenuItem
 * @since 1.0.0
 * @hidden
 */
export function DropdownMenuItem(props) {
    const { style, current, label, infos, image, picto, value, color } = Object.assign({ style: 'normal' }, props);
    /**
     * @function onClick
     * @since 1.0.0
     * @hidden
     */
    function onClick() {
        if (props.onClick) {
            props.onClick(value);
        }
    }
    /**
     * @function onMouseEnter
     * @since 1.0.0
     * @hidden
     */
    function onMouseEnter() {
        if (props.onMouseEnter) {
            props.onMouseEnter(value);
        }
    }
    /**
     * @function onMouseLeave
     * @since 1.0.0
     * @hidden
     */
    function onMouseLeave() {
        if (props.onMouseLeave) {
            props.onMouseLeave(value);
        }
    }
    const className = classNames('dropdown-menu-item', 'dropdown-menu-item--' + style, { 'dropdown-menu-item--has-picto': picto }, { 'dropdown-menu-item--has-label': label }, { 'dropdown-menu-item--has-infos': infos }, { 'dropdown-menu-item--current': current }, props.className);
    return (React.createElement("div", { className: className, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onClick: onClick },
        React.createElement("div", { className: "dropdown-menu-item-head" },
            picto && React.createElement(Icon, { className: "dropdown-menu-item-picto", value: picto }),
            image && React.createElement(Icon, { className: "dropdown-menu-item-image", value: image })),
        React.createElement("div", { className: "dropdown-menu-item-body" },
            color && (React.createElement("div", { className: !color.startsWith('#') ? classNames('dropdown-menu-item-color', 'dropdown-menu-item-color--' + color) : 'dropdown-menu-item-color', style: color.startsWith('#') ? { backgroundColor: color } : undefined })),
            label && React.createElement(Text, { className: "dropdown-menu-item-label", value: label }),
            infos && React.createElement(Text, { className: "dropdown-menu-item-infos", value: infos }))));
}
